var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-5 mt-5"},[_c('p',{staticClass:"display-1"},[_vm._v("404")]),_c('p',[_vm._v("Page Not Found")]),_c('router-link',{attrs:{"to":{ name: 'SupportTickets'}}},[_vm._v("Go To Tickets")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }